module.exports = __webpack_public_path__ + "img/cnvos-logo.4cfc75aa.png";